<div class="flex max-w-[320px] items-start gap-3 text-[#545661]">
  <l-icon class="mt-0.5 !text-xl text-[#6f6c90]">info</l-icon>
  <div class="space-y-1 text-sm leading-6">
    <p><span class="font-bold text-[#020209]">Ativo:</span> conta ativada</p>
    <p><span class="font-bold text-[#020209]">Pendente:</span> aguardando ativação</p>
    <p><span class="font-bold text-[#020209]">Expirado:</span> convite expirado (é necessário reenviar)</p>
  </div>
</div>
